/**
 * @description Appends an a key-value to the object
 * @param {*} obj
 * @param {*} appending_object
 * @returns
 */
export const objectAppend = (obj, appending_object) => {
  Object.keys(obj).forEach((key) => {
    const val = obj[key];
    if (typeof val === 'object' && !Array.isArray(val) && val !== null)
      obj[key] = { ...val, ...appending_object };
  });
  return obj;
};
